import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisconnect = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.1161 6.46445C8.87204 6.70857 8.47629 6.70857 8.23223 6.46445C7.9881 6.2204 7.9881 5.82467 8.23223 5.58059L10.4419 3.37089C12.1505 1.66234 14.9205 1.66234 16.6291 3.37089C18.3377 5.07943 18.3377 7.84951 16.6291 9.55807L14.4194 11.7678C14.1753 12.0119 13.7796 12.0119 13.5355 11.7678C13.2914 11.5237 13.2914 11.1279 13.5355 10.8839L15.7452 8.6742C16.9656 7.45382 16.9656 5.47515 15.7452 4.25477C14.5249 3.03438 12.5462 3.03438 11.3258 4.25477L9.1161 6.46445Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25475 4.25471C4.49882 4.01064 4.89455 4.01064 5.13863 4.25471L15.7452 14.8613C15.9893 15.1054 15.9893 15.5011 15.7452 15.7452C15.5012 15.9893 15.1054 15.9893 14.8614 15.7452L4.25475 5.1386C4.01067 4.89452 4.01067 4.49879 4.25475 4.25471Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.46442 8.23229C6.70855 8.47635 6.70855 8.8721 6.46442 9.11616L4.25474 11.3259C3.03435 12.5462 3.03435 14.5249 4.25474 15.7453C5.47513 16.9657 7.4538 16.9657 8.67417 15.7453L10.8839 13.5356C11.1279 13.2915 11.5237 13.2915 11.7677 13.5356C12.0118 13.7797 12.0118 14.1754 11.7677 14.4195L9.55805 16.6292C7.84949 18.3377 5.0794 18.3377 3.37085 16.6292C1.66231 14.9206 1.66231 12.1505 3.37085 10.442L5.58057 8.23229C5.82464 7.98816 6.22037 7.98816 6.46442 8.23229Z",
			fill: "currentColor"
		})
	] })
});
export default SvgDisconnect;
